export default "__VITE_ASSET__BDtAp9JI__"